// Google Ads (gtag.js) helpers. The base tag + Consent Mode default live in index.html.
const AW = "AW-342192845";

export const CONVERSIONS = {
  contactForm: `${AW}/Td2ACKHotsBCEM3llaMB`,
  call: `${AW}/iwWKCOPh2sBCEM3llaMB`,
  mail: `${AW}/02TGCIT02sBCEM3llaMB`,
};

// Update Google Consent Mode after the user's cookie choice.
export function gtagConsentUpdate(granted) {
  if (typeof window.gtag !== "function") return;
  const v = granted ? "granted" : "denied";
  window.gtag("consent", "update", {
    ad_storage: v,
    ad_user_data: v,
    ad_personalization: v,
    analytics_storage: v,
  });
}

export function fireConversion(sendTo) {
  if (typeof window.gtag !== "function" || !sendTo) return;
  window.gtag("event", "conversion", { send_to: sendTo });
}

// One delegated listener converts mailto/tel/WhatsApp link clicks.
export function initLinkConversionTracking() {
  if (window.__yblLinkConv) return;
  window.__yblLinkConv = true;
  document.addEventListener(
    "click",
    (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (href.startsWith("mailto:")) fireConversion(CONVERSIONS.mail);
      else if (href.startsWith("tel:") || href.includes("wa.me") || href.includes("whatsapp"))
        fireConversion(CONVERSIONS.call);
    },
    true
  );
}
